export default {
    companySetting: 'Company Setting',
    profile: 'Profile',
    branch: 'Branch',
    userManagement: 'User Management',
    department: 'Department',
    companyHoliday: 'Company Holiday',
    leaveQuota: 'Leave Quota',
    leaveType: 'Leave Type',
    savePlace: 'Save Place',
    blacklist: 'Blacklist'
}
